/** NexBe 전자서명 등 한 세션에서 선택 가능한 제공기관 수 상한 */
export const MAX_SELECTABLE_INSTITUTIONS = 50;
